<div class="c-block c-block--bordered">
  <dl class="c-detail__list">
    <dt class="c-detail__list-name">Income Details</dt>
  </dl>
  <div *ngFor="let i of incomeDetails">
    <div>
      <recap-income-applicant [incomeApplicant]="i"></recap-income-applicant>
    </div>
  </div>
  @if (showEditButton) {
    <button class="c-button c-button--neutral" type="button" (click)="editButtonClicked()">
      Edit income details
      <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.06 14.71"><path fill="none" stroke="#2f3432" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7" /></svg>
    </button>
  }
</div>
